import React from 'react';

import { useCopyStore } from 'store';

import * as NonFunctionalsStyles from './../NonFunctionals.styles';
import * as S from './WebGLDisabled.styles';

const WebGLDisabledProps = () => {
  const copies = useCopyStore(state => state.copy);

  if (!copies.global) return null;
  const {
    global: {
      errors: { webGLDisabled: copy },
    },
  } = copies;

  return (
    <S.Wrapper>
      <NonFunctionalsStyles.Title>{copy.title}</NonFunctionalsStyles.Title>
      <br />
      <NonFunctionalsStyles.Description
        dangerouslySetInnerHTML={{ __html: copy.body }}
      />
    </S.Wrapper>
  );
};

export default WebGLDisabledProps;
